var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0610352,
    y: 0.167969,
    width: 17.6383,
    height: 17.4926,
    fill: "url(#pattern0_1240_44120)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6992 6.33887L23.6435 11.4891L28.9998 6.33887",
    stroke: "#666666",
    strokeWidth: 1.03006
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1240_44120",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1240_44120",
    transform: "matrix(0.00991735 0 0 0.01 0.00413233 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1240_44120",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACAUlEQVR4nO3dPWoWURyF8RNQXIKCtSnMBiySZVhbvSlF0AWkDHZWb7KEZBdaTCV2llqJkw0IMhCPDLydmCiZj3PvfX7w7zP3QB5SRQIAAAAAAACABexLeivpQtIlp5vuYvdWT+Ya40jSD0nm9D83vtnhHIN8Cvg4F3ofpx7jvqRfAR/mQu9a0r2pR7kK+DAXet81gzcBH+ZC7/Ucg+xJeiXpK7++9C83vtEXSS93b7eYs4CPd8htFWAM/vuAx/DK10l6oBAPJX0LeBSvdL2kxwrzTNLPgMfxwjfs/miO9CLggbzwbRSupchvVYAx8h8CHsstRfw2jyqPfJ8Y8VYjPyRHvMXIb1S4miK/VQVqiXxXUsRrj3xfYsRrjfxQcsRrjPxGlSsp8mdqQCmR72qKeOmR72uMeKmRH2qOeImR36hx5wEjuKWIlxL5rqWIp0e+bzHiqZEfWo54YuSP1/7odOcLjkHEgyLfEfGcyPdEPCfyAxHPivzx2h8FAAAA/On5xIc78sSHOzKDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZDGDZPEE91nSiaSna39MDcwIWcwIWXzLjf+j45QRluO/jPBurv9+hpuZEbKcSDpY+4cAAAAAAAAAACX7DQujQMlCCchrAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8d25f73a45a54c19f8c39460006a867c.svg";
export { ForwardRef as ReactComponent };